import { Component, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AlertesService } from '../../services/public/alertes.service';
import { Config, NgxPrintElementService } from 'ngx-print-element';
import { AddPublicServiceComponent } from '../add-public-service/add-public-service.component';
import { CustomService } from '../../services/frapper/custom.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import html2pdf from 'html2pdf.js';
import { log } from 'console';
@Component({
  selector: 'app-document-generation-public',
  templateUrl: './document-generation-public.component.html',
  // styles: [':host{display:contents}'], // Makes component host as if it was not there, can offer less css headaches. Use @HostBinding class approach for easier overrides.
})
export class DocumentGenerationPublicComponent {
  SERVICE: any
  OPERATION_REF: any
  KEYS_GEN: any = []
  DEMANDE_TO_FORMS: any
  TEMPLATE: any
  CUSTOM_DATA: any
  link: any
  is_printing = false
  qrCodeimg = 'None'
  data: any;
  operation_ref: any;
  @ViewChild('elementToPrint') printElement!: any;
  modalRef?: BsModalRef;
  imageFile: any = {}

  constructor(
    private modalService: BsModalService,
    public options: ModalOptions,
    private alerte: AlertesService,
    public print: NgxPrintElementService,
    private ngxService: NgxUiLoaderService,
  ) {
    this.data = options.initialState.data;
    this.operation_ref = options.initialState.operation_ref;
    this.KEYS_GEN = options.initialState.KEYS_GEN;
    this.DEMANDE_TO_FORMS = options.initialState.data_from_request;
    this.CUSTOM_DATA = options.initialState.custom_data;

    try {
      this.CUSTOM_DATA = JSON.parse(this.CUSTOM_DATA)
    } catch (err) {
      this.CUSTOM_DATA = null
    }


    this.SERVICE = this.data
    this.OPERATION_REF = this.operation_ref
    this.KEYS_GEN = this.KEYS_GEN

    this.qrCodeimg = this.OPERATION_REF

    this.TEMPLATE = this.SERVICE.resp_template
    if (this.TEMPLATE == null) {
      alerte.warningNotification('', 'Aucune t\'emplate');
    }

    //console.log(this.KEYS_GEN)
    this.tranforKey()
  }


  closeAllDialogs() {
    this.modalService.hide();
  }


  tranforKey() {
    for (let val of this.KEYS_GEN) {
      try {
        const keys = Object.keys(val);
        const REST = this.KEYS_GEN.find((b: any) => b[keys[0]] != undefined)
        console.log(keys[0], ' ====> ', REST[keys[0]])
        this.TEMPLATE = this.TEMPLATE.replace('{' + keys[0] + '}', REST[keys[0]])
      } catch (e) {
        console.log('ERROR')
      }

    }
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const date = `${year}-${month}-${day}`;

    this.TEMPLATE = this.TEMPLATE.replace('{TODAY}', date)
  }

  public config: Config = {
    printMode: 'template', // template-popup
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    pageTitle: 'casier',

    // htmlType: 'text',
    stylesheets: [],

    styles: [
      `

      #papier{
        background: #802E2EFF;
      }
    `
    ]
  }

  onPrint2(el: any) {
    this.print.print(el, this.config).subscribe(console.log);

    // if(this.type=='unprint'){
    //   this.alerte.warningNotification('Casier','Impossible d\'imprimer en mode apercu !')
    // }else {
    //   try {
    //     this.print.print(el, this.config).subscribe(console.log);

    //   } catch (error) {
    //     console.log('dddddd==> '+ error);
    //   }
    // }
  }




  async openTraitementFormDialog() {
    console.log('operation sender :', this.CUSTOM_DATA);

    if (!this.CUSTOM_DATA.operation_sender) {
      this.alerte.warningNotification('Impossible de delivrer le document')

      return;
    }
    // get operation
    const key = 0;
    const pdfFile = await this.generateCasierPDF(key)

    // console.log('thissss pdf link from backend', pdfFile)

    // const url = URL.createObjectURL(pdfFile);
    // window.open(url, '_blank');
    const config: ModalOptions = {
      initialState: {
        data: this.SERVICE.related_service_detail,
        operation_ref: this.CUSTOM_DATA.operation_sender,
        show_signature: true,
        data_from_request: this.DEMANDE_TO_FORMS,
        file: pdfFile
      }
    }
    console.log('the service===> ', this.SERVICE);

    if (this.SERVICE.related_service_detail != null) {
      return new Promise<string>((resolve, reject) => {
        const modalRef = this.modalService.show(AddPublicServiceComponent, Object.assign({}, config, { class: 'modal-xl  ' }));
        modalRef.content.parentModal = modalRef;
        modalRef.onHidden.subscribe((value: string) => {
          console.log('after traiteme', value);
          resolve(value); // Résoudre la promesse avec la valeur retournée
          console.log('after traiteme', value);

        });
      }).then(async (value: string) => {
        if (value == "for_close") {
          console.log('inthe-view-details', value);

          this.closeWithMessage("for_refresh")
          // return this.getResponseOfTraitement(service, operation_ref, status, custom_data);

        }


      });

      // modalRef.content.parentModal = modalRef;

    } else {
      this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
    }

  }

  async generateCasierPDF(key: number) {
    this.ngxService.start()
    const element = this.printElement.nativeElement;

    const opt = {
      margin: 0.5,
      filename: 'casier.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };

    try {
      const pdfBlob: Blob = await html2pdf().set(opt).from(element).outputPdf('blob');

      const pdfFile = new File([pdfBlob], 'casier.pdf', { type: 'application/pdf' });
      return pdfFile;
    } catch (err) {
      this.alerte.errorNotification('PDF', 'Échec de la génération du PDF');
    } finally {
      this.ngxService.stop()
    }
  }


  closeWithMessage(message: string) {
    this.modalRef.hide();
    this.modalRef.onHidden.emit(message);
  }
  onPrint(divName: any) {


    // try {
    //   const printContents = document.getElementById(divName)?.innerHTML;

    //   if (printContents != null) {
    //     const printWindow = window.open('');
    //     printWindow!.document.write(printContents);
    //     printWindow!.document.close();
    //     printWindow!.focus();
    //     printWindow!.print();
    //     printWindow!.close();
    //   }

    //   this.closeAllDialogs();
    // } catch (e) {
    //   this.closeAllDialogs();
    // }
  }



  // onPrint(divName:any) {
  //   try{

  //     this.is_printing = false
  //     // const divName = 'papier';
  //     const originalContents = document.body.innerHTML;
  //     const printContents = document.getElementById(divName)?.innerHTML;

  //     if (printContents != null) {
  //     document.body.innerHTML = printContents;
  //     }

  //     window.print()
  //     // this.is_printing = false
  //     document.body.innerHTML = originalContents;



  //     // this.closeAllDialogs()


  //   }catch (e) {
  //     this.closeAllDialogs()
  //   }


  // }

  ngOnInit(): void {
  }


  launchDialog(dialogRef: any) {
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe();
  }
}
